import { Component, OnInit, inject, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Observable } from 'rxjs/internal/Observable';
import { CartPosition } from 'src/app/common/CartPosition';
import { CartService } from 'src/app/services/cart.service';
import { CallApiService } from '../../services/api-action.service';
import { AsyncClickDirective, AsyncClickLock } from '../../directives/async-click.directive';

@Component({
    imports: [FormsModule, AsyncClickDirective],
    selector: 'app-edit-cart-item',
    templateUrl: './edit-cart-item.component.html',
    styleUrls: ['./edit-cart-item.component.css']
})
export class EditCartItemComponent implements OnInit {
  private cartService = inject(CartService);
  private apiActionService = inject(CallApiService);

  readonly cartPosition = input<CartPosition>();
  public count: number;
  // Save and remove act on the same cart line — neither fires while the other runs.
  public cartItemLock: AsyncClickLock = { busy: false };

  ngOnInit(): void {
    this.count = this.cartPosition().count;
    if (!this.cartService.cart) {
      this.cartService.reloadCart();
    }
  }

  public removeCartItem(): Observable<unknown> {
    this.count = 0;
    return this.editCartItem();
  }

  public editCartItem(): Observable<unknown> {
    return this.apiActionService.callWithToasts$(
      this.cartService.editCartItem(this.cartPosition(), this.count),
      $localize`Der Warenkorb wurde aktualisiert.`,
      $localize`Bei der Aktualisierung des Warenkorbs ist ein Fehler aufgetreten.`);
  }
}
